import PropTypes from 'prop-types';
import React from 'react';

const Loader = ({ color = 'dark' }) => {
	const colors = { dark: 'border-dark', light: 'border-light' };

	return (
		<div className={`${colors[color]} text-center`}>
			<span className="loader"></span>
		</div>
	);
};

Loader.propTypes = {
	color: PropTypes.string,
};

export default Loader;
